module.exports = __webpack_public_path__ + "static/media/shared-space@2x.a0b692b6.jpg";